<template>

	<!-- Mobile Menu List -->
	<ul class="mobile-menu-list">
		<li class="mobile-menu-list__item">
			<account-switcher :rooms="rooms" :account="account" :overlay="false"></account-switcher>
		</li>

		<li class="mobile-menu-list__item">
			<!-- Select -->
			<div class="mobile-menu__select">
				<select2 class="select"
								 placeholder="Введите название города" v-model="city"
								 :httpOptions="httpConfig" :label="'name'" :id="'_id'"
								 @change="selectCity">
					<option :value="currentCity._id" slot="defaultValue" v-if="currentCity._id">{{currentCity.name}}</option>
				</select2>
			</div>
			<!-- Select End -->
		</li>

		<li class="mobile-menu-list__item" @click="toggleMenu" v-if="(!isDoctor || !inCabinet)">
			<router-link to="/doctors" class="mobile-menu-list__link">Врачи</router-link>
		</li>
		<li class="mobile-menu-list__item" @click="toggleMenu" v-if="(!isDoctor || !inCabinet)">
			<router-link to="/clinics" class="mobile-menu-list__link">Клиники</router-link>
		</li>

		<!-- Mobile Menu List -->
		<ul class="mobile-menu-list">
			<li class="mobile-menu-list__item">
				<p class="mobile-menu__text">Кабинет</p>
			</li>

			<li class="mobile-menu-list__item">
				<a class="mobile-menu-list__link" @click="expandMenu($event)">
					Мой кабинет
					<i class="icon icon_right-arrow ion-ios-arrow-right icon_blue"></i>
				</a>

				<!-- Mobile Submenu List -->
				<ul class="mobile-submenu-list">

					<li class="mobile-submenu-list__item" @click="toggleMenu">
						<router-link :to="{path: '/cabinet/' + account._id + '/own/events'}"
												 class="mobile-submenu-list__link">
							Мои события
						</router-link>
					</li>
					<li class="mobile-submenu-list__item" @click="toggleMenu">
						<router-link :to="{path: '/cabinet/' + account._id + '/own/visits'}"
												 class="mobile-submenu-list__link">
							Визиты
						</router-link>
					</li>
				</ul>
				<!-- Mobile Submenu List -->
			</li>

			<li class="mobile-menu-list__item" v-if="isDoctor">
				<a class="mobile-menu-list__link" @click="expandMenu($event)">
					Клиника
					<i class="icon icon_right-arrow ion-ios-arrow-right icon_blue"></i>
				</a>

				<!-- Mobile Submenu List -->
				<ul class="mobile-submenu-list">

					<li class="mobile-submenu-list__item" @click="toggleMenu">
						<router-link
							:to="{path: '/cabinet/' + account._id + '/clinic/' + account.clinic_id + '/personal'}"
							class="mobile-submenu-list__link">
							Сотрудники
						</router-link>
					</li>

					<li class="mobile-submenu-list__item" @click="toggleMenu">
						<router-link
							:to="{path: '/cabinet/' + account._id + '/clinic/' + account.clinic_id + '/patients'}"
							class="mobile-submenu-list__link">
							Пациенты
						</router-link>
					</li>

					<li class="mobile-submenu-list__item" @click="toggleMenu">
						<router-link
							:to="{path: '/cabinet/' + account._id + '/clinic/' + account.clinic_id + '/profile/'+ account._id}"
							class="mobile-submenu-list__link">
							Профиль
						</router-link>
					</li>
				</ul>
				<!-- Mobile Submenu List -->

			</li>
			<li class="mobile-menu-list__item" v-if="isDoctor" @click="toggleMenu">
				<router-link :to="{path: '/cabinet/' + account._id + '/registry/' + account.clinic_id}"
										 class="mobile-menu-list__link">Регистратура
				</router-link>
			</li>

			<li class="mobile-menu-list__item" v-if="!isDoctor">
				<a class="mobile-menu-list__link" @click="expandMenu($event)">Карточка
					<i class="icon icon_right-arrow ion-ios-arrow-right icon_blue"></i>
				</a>

				<!-- Mobile Submenu List -->
				<ul class="mobile-submenu-list">
					<li class="mobile-submenu-list__item" @click="toggleMenu">
						<router-link :to="{path: '/cabinet/' + account._id + '/card'}" class="mobile-submenu-list__link">
							Основное
						</router-link>
					</li>

				</ul>
				<!-- Mobile Submenu List -->
			</li>
		</ul>
		<!-- Mobile Menu List -->

		<!--<p class="mobile-text-info">
			Сервис запущен в тестовом режиме. В случае
			возникновения неполадок, вопросов, замечаний
			или пожеланий, звоните +380669343289. Спасибо!
		</p>-->

	</ul>
	<!-- Mobile Menu List End -->

</template>
<script>
	import AccountSwitcher from '@/components/header/AccountSwitcher.vue'

	export default {
		name: "mobileHeader",
		props: ['account', 'rooms', 'currentCity'],
		components: {AccountSwitcher},
		computed: {
			logged() {
				return this.$store.state.auth.logged
			},
			isDoctor() {
				return this.$store.state.auth.isDoctor
			},
			user() {
				return this.$store.state.auth.user
			},
			worker() {
				return this.$store.state.auth.worker
			},
			clinic() {
				return this.$store.state.auth.clinic
			},
			inCabinet() {
				return /\/cabinet\/[a-z0-9]+/.test(this.$route.fullPath)
			}
		},
		data() {
			return {
				city: this.currentCity._id,
				httpConfig: {
					url: process.env.API_LINK + '/city/all/get',
					method: 'GET',
					data: {
						term: this.city
					}
				}
			}
		},
		methods: {
			toggleMenu() {
				$('.mobile-menu-list')
					.stop(true, true)
					.slideToggle();
			},
			expandMenu(e) {
				let listEl = (e.target.nodeName === 'I')
					? $(e.target).parent().next()
					: $(e.target).next();

				let displayOfListEl = getComputedStyle(listEl[0]).display;

				if(displayOfListEl === 'block') {
					listEl.stop(true, true).slideToggle();
				} else {
					$('.mobile-submenu-list', e.target.parentNode.parentNode).stop(true, true).slideUp();
					listEl.stop(true, true).slideToggle();
				}
			},
			toggleRegistry() {
				this.$event.send('toggleRegistryMenu', {})
			},
			selectCity(id) {
				this.$emit('selectCity', id)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// mobileHeader.vue?6c54ca1a